import loadable from "@loadable/component";
import { loadableAuthParams } from "@components/Skeleton/loadableParams";

export default loadable(
  async () => import("./RedirectPage"),
  loadableAuthParams
);
